<template>
    <div class="overflow-y-auto p-8 bg-blue-gray-50">
        <ContentBlock v-for="(block, index) in blocks" :key="block.id" :block="block" :index="index"
            :all-blocks="blocks" />
    </div>
</template>

<script>
import { reactive } from 'vue';
import ContentBlock from '@/components/general/ContentBlock.vue';

export default {
    name: 'ContentModule',
    components: {
        ContentBlock, // Registering the ContentBlock component
    },
    props: {
        event: {
            type: Object,
            required: true,
        },
    },
    setup() {
        const toggles = reactive({}); // Track toggle states
        return { toggles };
    },
    computed: {
        blocks() {
            return this.event.content?.blocks || [];
        },
    },
};
</script>
<style scoped>
/* Add your styles here */
</style>